import c from '../../../util/const'
import log from '../../../util/log'
import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import Button from "../elements/Button";
import { AiOutlineFileAdd } from 'react-icons/ai';
import {withVFTranslation} from "../../../util/withVFTranslation";
import colors from "../../../util/colors";

class PdfSigningV1Header extends Component {

  render() {
    let { nextBtnDisabled, nextBtnText, hideCancelBtn, textPrompt, t } = this.props;

    return (
      <>
        <div className="container-fluid signing-bg light-color pt-2"  style={{
          borderBottom: `5px solid ${colors.SIGNING}`
        }}>
          <div className="row align-items-center my-2 pb-2">
            <div className="col-8">
              <Button className="btn btn-sm btn-outline-light signingv1"
                      onClick={() => this.props.addAnnotationClick()}>
                <i className="icon ion-edit me-1"/>
                {t("Add Annotation")}
              </Button>
              <Button className="btn btn-sm btn-outline-light signingv1 ms-2"
                      onClick={() => this.props.addSignatureClick()}>
                <i className="icon ion-edit me-1"/>
                {t("Add Signature")}
              </Button>
              <Button className="btn btn-sm btn-outline-light signingv1 ms-2"
                      onClick={() => this.props.mergePdfsClick()}>
                <AiOutlineFileAdd className="icon me-1" />
                {t("Merge Documents")}
              </Button>
            </div>
            <div className="col-4 align-items-center">
                <div className="d-flex justify-content-end">
                  <div className="d-inline-flex align-self-center">
                    {!hideCancelBtn &&
                      <Button className="btn btn-sm btn-outline-light signingv1 mx-3"
                              onClick={() => this.props.cancelBtnClick()}>
                        {t("Cancel")}
                      </Button>
                    }
                    <Button className="btn btn-sm btn-outline-light signingv1"
                            disabled={nextBtnDisabled}
                            onClick={() => this.props.nextBtnClick()}>
                      {nextBtnText ? nextBtnText : t("Next")}
                    </Button>
                  </div>
                </div>
            </div>
          </div>
          <div className="row mt-1 light-bg dark-color">
            <div className="col">
              <div className="text-center py-1"
                   style={{
                     fontSize: '14px',
                   }}>
                {textPrompt}
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

const styles = {

}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {};
};

PdfSigningV1Header.propTypes = {
  textPrompt : PropTypes.string.isRequired,
  nextBtnText : PropTypes.string,
  nextBtnDisabled: PropTypes.bool.isRequired,
  nextBtnClick : PropTypes.func.isRequired,
  cancelBtnClick : PropTypes.func.isRequired,
  hideCancelBtn : PropTypes.bool,
  addAnnotationClick : PropTypes.func.isRequired,
  addSignatureClick : PropTypes.func.isRequired,
  mergePdfsClick : PropTypes.func.isRequired
}

export default withVFTranslation()(connect(mapStateToProps, mapDispatchToProps)(PdfSigningV1Header));
